$("#distributor-filter-current-location, #distributor-filter-location-search-submit").click(function () {
    $(".distributor-list-wrapper").show();
    $(".distributor-map-wrapper").removeClass("col-lg-12")
    $(".distributor-map-wrapper").addClass("col-lg-8")
});


let distributorWidgetInput = document.querySelector("#distributor-location-widget-search-input")
let distributorPageInput = document.querySelector("#distributor-filter-location-search")

if (distributorWidgetInput) {
    distributorWidgetInput.onkeyup = function(event) {
        if (event.keyCode == 13 || event.keyCode == "Enter") {
            document.querySelector('#distributor-location-widget-search-submit').click();
        }
    }
}

if (distributorPageInput) {
    distributorPageInput.onkeyup = function(event) {
        if(event.keyCode == 13 || event.keyCode == "Enter"){
            document.querySelector('#distributor-filter-location-search-submit').click();
        }
    }
}


function __initProductQuickSearchWidget() {
    $('#distributor-location-widget-search-submit').click(function (e) {
        e.preventDefault();
        var q = $('#distributor-location-widget-search-input').val();
        if (q.length > 0) {
            window.location = '/buy-waratah?q=' + q;
        }
    })
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        __initProductQuickSearchWidget()
    });
} else {
    __initProductQuickSearchWidget()
}